/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_BrowseInputs */

const en_directory_rails_browse = /** @type {(inputs: Directory_Rails_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse`)
};

const zh_directory_rails_browse = /** @type {(inputs: Directory_Rails_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览`)
};

/**
* | output |
* | --- |
* | "Browse" |
*
* @param {Directory_Rails_BrowseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_browse = /** @type {((inputs?: Directory_Rails_BrowseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_BrowseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_browse(inputs)
	return zh_directory_rails_browse(inputs)
});
export { directory_rails_browse as "directory.rails.browse" }